// import Web3 from "web3";

export const wearExchangeContractABI = require("../contracts/WearExchange.json");
export const wearListContractABI = require("../contracts/WearListing.json");
export const wearNftContractABI = require("../contracts/WearNft.json");
export const wearNftContractAddress = "0x36c4e883e4e9d10feb23e754c377fdcce0dc7886";
export const wearExchangeContractAddress = "0xe91e7f0a391f502ed0e7e7f318add58c0d742093";
export const supportedNftCollectionAddresses = ["0x36c4e883e4e9d10feb23e754c377fdcce0dc7886"]